<template>
  <ApplicationWrapper>
    <template slot="header">
      <h3 :style="'text-wrap: balance;' + isMobile() ? 'text-align: center' : ''">
        {{ $t('common.label_clubNotFound') }}
      </h3>
    </template>
    <template slot="details">
      <!-- last club num dialog -->
      <v-dialog v-model="showLastClubNumDialog" width="auto" persistent absolute="absolute">
        <v-card>
          <v-card-title class="text-h5"> {{ $t('common.label_previousClubFound') }} </v-card-title>
          <v-card-text>
            <div v-html="$t('common.label_previousClubNumFound', [lastClubName, lastClubNum])" />
          </v-card-text>
          <v-card-actions>
            <v-btn :loading="retryButtonLoading" @click="showLastClubNumDialog = false"> {{ $t('common.label_no') }} </v-btn>
            <v-spacer></v-spacer>
            <v-btn :loading="retryButtonLoading" @click="handleNavigateToLastClub">
              {{ $t('common.label_yes') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <Detail :containerNoMargin="true" class="ma-4">
        <template slot="content-override">
          <v-row no-gutters class="flex-row" justify="center" align="center" style="gap: 32px">
            <v-card class="pa-2" style="text-align: center">
              <v-col>
                <h4 v-if="clubNumOrigin <= 0">{{ $t('errors.noClubNum') }}</h4>
                <h4 v-else>{{ $t('errors.clubNumNotFound', [clubNumOrigin]) }}</h4>
                <br />
                {{ $t('errors.clubNumInfoLine1') }}
                <br />
                {{ $t('errors.clubNumInfoLine2') }}
              </v-col>
              <v-row no-gutters align="center" justify="center" style="gap: 16px">
                <v-col cols="12" sm="3">
                  <v-text-field
                    v-model="clubNumToRetry"
                    type="number"
                    @keydown.enter="checkNewClubNum(clubNumToRetry)"
                    :label="$t('common.label_clubNumber')"
                    prepend-icon="mdi-town-hall"
                    clearable />
                </v-col>
              </v-row>
            </v-card>
          </v-row>
        </template>
      </Detail>
    </template>
    <template slot="actionbuttons">
      <v-btn
        color="primary"
        :loading="retryButtonLoading"
        @click="checkNewClubNum(clubNumToRetry)"
        :disabled="clubNumToRetry == undefined || clubNumToRetry <= 0">
        <v-icon> mdi mdi-reload-alert </v-icon>
        {{ $t('common.label_tryAgain') }}
      </v-btn>
    </template>
  </ApplicationWrapper>
</template>

<script>
// Api
import { Api } from '@/api/apiAccess.ts';

// Components
import ApplicationWrapper from '@/components/controls/ApplicationWrapper.vue';
import Detail from '@/components/controls/Detail.vue';

// Mixins
import HelpersMixin from '@/mixins/helpers.js';

export default {
  name: 'NotFound',
  mixins: [HelpersMixin],
  components: { ApplicationWrapper, Detail },

  async mounted() {
    this.clubNumOrigin = this.$route.params.clubId ? this.$route.params.clubId : '';
    this.clubNumToRetry = this.$route.params.clubId ? this.$route.params.clubId : '';
    // get last club number out of cookies
    this.lastClubNum = this.getCookie(this.COOKIEKEY_LASTCLUBNUM);

    if (this.lastClubNum) {
      try {
        var clubLoginViewModel = { VereinsNummer: this.$route.params.clubId, Passwort: 'superSecurePassword' };
        var clubNumberExists = (await Api.HaKuBu.haKuBuVereinsLogin(clubLoginViewModel)).data.LoginId != -2;
      } catch (error) {
        this.$root.snackbar.show(this.$root.snackbars.genericError);
        this.configurationOk = 1;
        return;
      }

      // if the cookie and the club exists, ask the user if he wants to proceed with the last club
      if (clubNumberExists && this.lastClubNum && this.lastClubNum > 0) {
        try {
          // load club data to get the name of the club
          var clubData = (await Api.HaKuBu.haKuBuGetClubData(500, 500, this.lastClubNum)).data;
          this.showLastClubNumDialog = true;
          this.lastClubName = clubData.Vereins_Name;
        } catch (error) {
          this.$root.snackbar.show(this.$root.snackbars.genericError);
          this.configurationOk = 1;
          return;
        }
      }
    }
  },

  data() {
    return {
      clubNumOrigin: undefined,
      clubNumToRetry: undefined,
      retryButtonLoading: false,
      lastClubNum: null,
      lastClubName: null,
      showLastClubNumDialog: false,
      loading: false,
    };
  },

  methods: {
    handleNavigateToLastClub() {
      this.retryButtonLoading = true;

      var routeToLogin = this.$router.resolve({ name: 'Index', params: { clubId: this.lastClubNum } }).href;
      this.$root.snackbar.show(this.$root.snackbars.clubNumFound(this.lastClubNum));

      // wait 1.5 seconds until the snackbar has disappeared
      setTimeout(() => {
        this.retryButtonLoading = false;
        window.location = routeToLogin;
      }, 1500);
    },

    async checkNewClubNum(clubNumToCheck) {
      if (this.clubNumToRetry == undefined || this.clubNumToRetry <= 0) return;

      this.retryButtonLoading = true;
      var clubLoginViewModel = { VereinsNummer: clubNumToCheck, Passwort: 'interessiert nicht', CvpSecret: 'interessiert noch weniger' };
      var clubNumberExists = (await Api.HaKuBu.haKuBuVereinsLogin(clubLoginViewModel)).data.LoginId != -2;

      // Before forwarding to the login page, check whether the newly entered club number can be assigned to a club
      if (!clubNumberExists) {
        this.clubNumOrigin = clubNumToCheck;
        this.clubNumToRetry = clubNumToCheck;
        this.$root.snackbar.show(this.$root.snackbars.clubNumNotFound(clubNumToCheck));
        this.retryButtonLoading = false;
        return;
      }

      var routeToLogin = this.$router.resolve({ name: 'Index', params: { clubId: this.clubNumToRetry } }).href;
      this.$root.snackbar.show(this.$root.snackbars.clubNumFound(clubNumToCheck));

      // wait 1.5 seconds until the snackbar has disappeared
      setTimeout(() => {
        this.retryButtonLoading = false;
        window.location = routeToLogin;
      }, 1500);
    },
  },
};
</script>

<style>
.not-found {
  /* behavior */
  font-size: 64px;
  font-weight: bold;
}
</style>
